module.exports = __webpack_public_path__ + "static/media/logoorange.6f4d1e14.png";